import React from "react";

export default function Version() {
  return (
    <div>
      <p className="version">Version 2024.02.27</p>
    </div>
  );
}
